module.exports = __webpack_public_path__ + "resources/img/sp_remoteview.fdf5fde5892f065ee8786ef177257818.png";